import React from "react";
import { Mutation } from "@apollo/client/react/components";
import { gql } from "@apollo/client";
import Icon from "@/common/UI/Icon";
import variables from "@/common/globalVariables";
import { ME_USER_QUERY } from "@/graphql/queries/users";
import { CSSTransition } from "react-transition-group";
import { Button } from "semantic-ui-react";
import { StyledAnimatedButton } from "./FavoriteButton";

const USER_DELETE_FAVORITE_MUTATION = gql`
  mutation USER_DELETE_FAVORITE_MUTATION($jobId: ID!) {
    deleteFavorite(job: $jobId)
  }
`;

const update = (cache, payload) => {
  const jobId = payload.data.deleteFavorite;
  try {
    const data = cache.readQuery({
      query: ME_USER_QUERY,
    });

    if (!data?.me) return;
    cache.writeQuery({
      query: ME_USER_QUERY,
      data: {
        me: {
          ...data.me,
          favorites: (data.me.favorites || []).filter(
            (favorite) => favorite.job.id !== jobId
          ),
        },
      },
    });
  } catch (err) {
    return;
  }
};

const favoriteButtonWrapper = ({
  jobId,
  show,
  count,
  loading,
  compact,
  inFlow,
}) => {
  return (
    <Mutation
      mutation={USER_DELETE_FAVORITE_MUTATION}
      variables={{ jobId }}
      update={update}
      optimisticResponse={{
        deleteFavorite: jobId,
      }}
    >
      {(removeFavoriteMutation, { data, error, called }) => {
        if (error) return <p>Error</p>;
        return (
          <CSSTransition
            unmountOnExit
            in={show}
            className="RemoveFavorite"
            key={jobId + "Remove"}
            timeout={{ enter: 300, exit: 300 }}
          >
            <StyledAnimatedButton
              className="AnimatedButton"
              $inFlow={!!(compact || inFlow)}
            >
              <Button
                color="blue"
                content="Like"
                icon="heart"
                size={compact ? "mini" : "small"}
                compact={!!compact}
                loading={loading}
                label={{
                  basic: true,
                  color: "blue",
                  pointing: "left",
                  content: count,
                  size: "mini",
                }}
                onClick={removeFavoriteMutation}
              />
            </StyledAnimatedButton>
          </CSSTransition>
        );
      }}
    </Mutation>
  );
};

export default favoriteButtonWrapper;
